import './style.css'
const Notice = () => {
 return (
  <div className='notice' >
   <span>
    attention please !! this is a social media app for education purposes only
   </span>
  </div >
 )
};
export default Notice;
